// eslint-disable-next-line import/prefer-default-export
export const POPULAR_CITIES = [
	{
		location: {
			id: 1,
			identifier: "1",
			type: "CustomLocation",
			name: "Anywhere in India",
		},
		display_text: "Anywhere in India",
	},
	{
		location: {
			id: 0,
			identifier: "651d470183cff884b7404dc4",
			type: "NBCluster",
			name: "Delhi-NCR",
		},
		display_text: "Delhi-NCR",
	},
	{
		location: {
			id: 0,
			identifier: "651d470083cff884b7404db1",
			type: "NBCluster",
			name: "Mumbai Metropolitan Region",
		},
		display_text: "Mumbai Metropolitan Region",
	},
	{
		location: {
			id: 0,
			identifier: "651d46ff83cff884b7404dad",
			type: "NBCluster",
			name: "Bengaluru Region",
		},
		display_text: "Bengaluru Region",
	},
	{
		location: {
			id: 0,
			identifier: "651d470183cff884b7404dba",
			type: "NBCluster",
			name: "Kolkata Region",
		},
		display_text: "Kolkata Region",
	},
	{
		location: {
			id: 0,
			identifier: "651d46fe83cff884b7404d96",
			type: "NBCluster",
			name: "Hyderabad Region",
		},
		display_text: "Hyderabad Region",
	},
];
